import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { SelectOption } from '@app/shared/models';
import { environment } from '@env/environment';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { FormLanguagesService } from '@app/form-languages';
import { TranslateService } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-language-switch',
    templateUrl: './language-switch.component.html',
    styleUrls: ['./language-switch.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass],
})
export class LanguageSwitchComponent implements OnInit, OnDestroy {
    private translateService = inject(TranslateService);
    private formLanguagesService = inject(FormLanguagesService);
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);
    private cdr = inject(ChangeDetectorRef);

    languagesOptions: SelectOption[];

    selectedLanguage: string;

    subscriptions$ = new Subscription();

    ngOnInit(): void {
        this.languagesOptions = this.setOptions(environment.formLanguages);

        this.subscriptions$.add(
            this.activatedRoute.queryParams
                .pipe(
                    tap((params: Params) => {
                        if (!params.locale) {
                            this.selectedLanguage = this.getDefaultLanguage();
                            this.formLanguagesService.current$.next(this.selectedLanguage);
                        } else {
                            this.selectedLanguage = <string>params.locale;
                            this.formLanguagesService.current$.next(<string>params.locale);
                        }
                        this.cdr.markForCheck();
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.formLanguagesService.current$.next(null);
        this.subscriptions$.unsubscribe();
    }

    setOptions(languages: string[]): SelectOption[] {
        return languages.map((language: string) => {
            return { name: language.toUpperCase(), value: language };
        });
    }

    changeLanguage(language: string): void {
        void this.router.navigate(['.'], { queryParams: { locale: language }, relativeTo: this.activatedRoute });
    }

    private getDefaultLanguage(): string {
        const shortLang = this.translateService.currentLang.slice(0, 2);
        if (this.languagesOptions.map((lang) => lang.value).includes(shortLang)) {
            return shortLang;
        }
        return 'pl';
    }
}
